import React from "react";
import { NavigationRouter } from "xa-navigation";
import { Switch, withRouter, RouteComponentProps } from "react-router-dom";
import ProjectsController from "./components/Projects/Controller/ProjectsController";
import ProjectController from "./components/Layout/Controller/ProjectController";
import LoginController from "./components/Login/Controller/LoginController";
import Unauthorized from "./components/Unauthorized/Unauthorized";
import { ADMIN, DEFAULT } from "./static/AccessLevels.static";

const App: React.FC<RouteComponentProps> = (props) => {
    return (
        <Switch>
            <NavigationRouter path="/login" component={LoginController} exact={true} />
            <NavigationRouter
                path="/project/:id"
                component={ProjectController}
                requiredLevel={[DEFAULT.level, ADMIN.level]}
                exact={true}
            />
            <NavigationRouter
                path="/"
                component={ProjectsController}
                requiredLevel={[DEFAULT.level, ADMIN.level]}
                exact={true}
            />
            <NavigationRouter path="/unauthorized" component={Unauthorized} exact />
        </Switch>
    );
};

export default withRouter(App);
